import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { TransactionRecordCategoryEnum } from '../enums/transaction-record-category.enum';
import { TransactionStatusEnum } from '../enums/transaction-status.enum';
import { TransactionTypeEnum } from '../enums/transaction-type.enum';

import { TransactionLinksDto } from './transaction-links.dto';

/**
 * Transaction DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.TRANSACTION)
export class TransactionSearchDto extends BaseSearchDto {
  code!: string;
  status!: TransactionStatusEnum;
  recordCategory!: TransactionRecordCategoryEnum;
  type!: TransactionTypeEnum;
  externalReference?: string | null;
  links?: TransactionLinksDto | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
  vehicleVin?: string | null;
  vehicleLicensePlate?: string | null;
  locationName?: string | null;
  rentalAgreementDocumentNumber?: string | null;
  rentalReservationCode?: string | null;
  maintenanceCode?: string | null;
  insuranceCode?: string | null;
  roadWorthyCheckCode?: string | null;
  roadTaxCode?: string | null;
  customerContactShortName?: string | null;
  supplierContactShortName?: string | null;
  agentContactShortName?: string | null;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  computedTotalAllocated!: number;
  computedTotalUnallocated!: number;
}
